import styled from 'styled-components';

export * from './global-styles';

export const CollapseArea = styled.div<{ open: boolean }>`
    transition: max-height 0.25s ease-in-out;
    max-height: ${({ open }) => (open ? '100vh' : '0')};
    overflow: hidden;
`;
